import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface ButtonProps {
  children: ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function Button({
  children,
  href = '[CART_LINK]',
  className = '',
  fullWidth = false,
  showIcon = true
}: ButtonProps) {
  return <a href={href} className={`
        inline-flex items-center justify-center 
        bg-gold hover:bg-gold-600 text-navy-900 
        font-bold text-lg md:text-xl py-4 px-8 
        rounded-lg shadow-[0_4px_14px_0_rgba(201,168,76,0.39)] 
        hover:shadow-[0_6px_20px_rgba(201,168,76,0.23)] 
        transition-all transform hover:-translate-y-1 
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} data-id="element-340">
      {children}
      {showIcon && <ChevronRightIcon className="ml-2 w-6 h-6" data-id="element-341" />}
    </a>;
}